import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

export const contactMarketingEmailPreferences = {
  update: ({
    contactSqid,
    params = {},
  }: {
    contactSqid: string;
    params?: Params;
  }) =>
    buildPath(
      `/internal_api/contacts/${contactSqid}/marketing_email_preference`,
      params,
    ),
};
